import {useVariationParams} from '@salesforce/retail-react-app/app/hooks/use-variation-params';

/**
 * @override
 *  - Return the first variant if there are multiple variants with the same variation params
 *  - Filter variants to only include orderable items
 *
 * This hook returns the currently selected
 * variant or undefined. NOTE: All attributes must be selected before a variant
 * will be returned. Only orderable variants are considered.
 *
 * @param {Object} product
 * @param {Boolean} isProductPartOfSet
 * @param {Boolean} isProductPartOfBundle
 * @returns {Object} the currently selected `Variant` object.
 */
export const useVariant = (
  product = {},
  isProductPartOfSet = false,
  isProductPartOfBundle = false
) => {
  const {variants = []} = product;
  const variationParams = useVariationParams(product, isProductPartOfSet, isProductPartOfBundle);

  // Get a filtered array of variants. The resulting array will only have variants
  // which have all the current variation params values set and are orderable.
  const filteredVariants = variants.filter(({variationValues, orderable}) => {
    // Return true if the variant is orderable and has all the same attribute values as the passing in params.
    return orderable && Object.keys(variationParams).every((key) => variationValues[key] === variationParams[key]);
  });

  return filteredVariants.length > 0 ? filteredVariants[0] : undefined;
};
